/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The SystemControllerDtoMnGnbDetailResponse model module.
 * @module model/SystemControllerDtoMnGnbDetailResponse
 * @version 1.0
 */
class SystemControllerDtoMnGnbDetailResponse {
    /**
     * Constructs a new <code>SystemControllerDtoMnGnbDetailResponse</code>.
     * @alias module:model/SystemControllerDtoMnGnbDetailResponse
     */
    constructor() { 
        
        SystemControllerDtoMnGnbDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoMnGnbDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnGnbDetailResponse} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnGnbDetailResponse} The populated <code>SystemControllerDtoMnGnbDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnGnbDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('gnbName')) {
                obj['gnbName'] = ApiClient.convertToType(data['gnbName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('icon')) {
                obj['icon'] = ApiClient.convertToType(data['icon'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnGnbDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnGnbDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['gnbName'] && !(typeof data['gnbName'] === 'string' || data['gnbName'] instanceof String)) {
            throw new Error("Expected the field `gnbName` to be a primitive type in the JSON string but got " + data['gnbName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['icon'] && !(typeof data['icon'] === 'string' || data['icon'] instanceof String)) {
            throw new Error("Expected the field `icon` to be a primitive type in the JSON string but got " + data['icon']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
SystemControllerDtoMnGnbDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
SystemControllerDtoMnGnbDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
SystemControllerDtoMnGnbDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
SystemControllerDtoMnGnbDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
SystemControllerDtoMnGnbDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnGnbDetailResponse.prototype['gnbNo'] = undefined;

/**
 * @member {String} gnbName
 */
SystemControllerDtoMnGnbDetailResponse.prototype['gnbName'] = undefined;

/**
 * @member {String} pageUrl
 */
SystemControllerDtoMnGnbDetailResponse.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
SystemControllerDtoMnGnbDetailResponse.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
SystemControllerDtoMnGnbDetailResponse.prototype['enabled'] = undefined;

/**
 * @member {String} icon
 */
SystemControllerDtoMnGnbDetailResponse.prototype['icon'] = undefined;

/**
 * @member {String} key
 */
SystemControllerDtoMnGnbDetailResponse.prototype['key'] = undefined;






export default SystemControllerDtoMnGnbDetailResponse;

